const RunVote = () => {
  return(
    <div>lets run a vote</div>
  );
}

export default RunVote;